import React from 'react'

const StockReportsSummaryTableHeader = () => {
  return (
    <>
    <tr>
    <th className='align-middle' rowSpan={2}>Stock Name</th>
      <th  rowSpan={1} colSpan={3}>Opening Balance</th>
      <th rowSpan={1} colSpan={3}>Inward</th>
      <th rowSpan={1} colSpan={3}>Outward</th>
      <th  rowSpan={1} colSpan={3}>Closing Balance</th>
    </tr>
    <tr>
      <th>Qty</th>
      <th>Rate</th>
      <th>Value</th>
      <th>Qty</th>
      <th>Rate</th>
      <th>Value</th>
      <th>Qty</th>
      <th>Rate</th>
      <th>Value</th>
      <th>Qty</th>
      <th>Rate</th>
      <th>Value</th>
    </tr>
  </>
  )
}

export default StockReportsSummaryTableHeader